module.exports = __webpack_public_path__ + "static/media/html.0caacd80.svg";